/**
 * @file: Activity.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 家长活动日
 */
import request from '@/utils/request'

/**
 * 小程序-获取食堂上次家长活动日详情(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function activityActivityAppletActBeforeGet(data) {
  return request({
    type: 'biz',
    url: 'activity/activity/applet/act/before/get',
    method: 'post',
    data
  })
}

/**
 * 小程序-判断食堂是否有开放日活动(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function activityActivityAppletActCheck(data) {
  return request({
    type: 'biz',
    url: 'activity/activity/applet/act/check',
    method: 'post',
    data
  })
}

/**
 * 小程序-整改处理(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function activityActivityAppletActDealCreate(data) {
  return request({
    type: 'biz',
    url: 'activity/activity/applet/act/deal/create',
    method: 'post',
    data
  })
}

/**
 * 小程序-获取食堂下所有未结束活动(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function activityActivityAppletActDoingList(data) {
  return request({
    type: 'biz',
    url: 'activity/activity/applet/act/doing/list',
    method: 'post',
    data
  })
}

/**
 * 小程序-活动推荐检查项(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function activityActivityAppletActRecommendCheck(data) {
  return request({
    type: 'biz',
    url: 'activity/activity/applet/act/recommend/check',
    method: 'post',
    data
  })
}

/**
 * 小程序-视频列表(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function activityActivityAppletActVideoList(data) {
  return request({
    type: 'biz',
    url: 'activity/activity/applet/act/video/list',
    method: 'post',
    data
  })
}

/**
 * 小程序-视频fileId保存(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function activityActivityAppletActVideoSave(data) {
  return request({
    type: 'biz',
    url: 'activity/activity/applet/act/video/save',
    method: 'post',
    data
  })
}

/**
 * 小程序-抽检巡检清单(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function activityActivityAppletCheckListGet(data) {
  return request({
    type: 'biz',
    url: 'activity/activity/applet/check/list/get',
    method: 'post',
    data
  })
}

/**
 * 小程序-获取活动细则(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function activityActivityAppletDetailGet(data) {
  return request({
    type: 'biz',
    url: 'activity/activity/applet/detail/get',
    method: 'post',
    data
  })
}

/**
 * 小程序-开放日评价(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function activityActivityAppletEvaluateCreate(data) {
  return request({
    type: 'biz',
    url: 'activity/activity/applet/evaluate/create',
    method: 'post',
    data
  })
}

/**
 * 小程序-开放日报名(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function activityActivityAppletRegistCreate(data) {
  return request({
    type: 'biz',
    url: 'activity/activity/applet/regist/create',
    method: 'post',
    data
  })
}

/**
 * 自动获取抽查清单(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function activityActivityAutoCheckItem(data) {
  return request({
    type: 'biz',
    url: 'activity/activity/auto/check/item',
    method: 'post',
    data
  })
}

/**
 * 新增活动(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function activityActivityCreate(data) {
  return request({
    type: 'biz',
    url: 'activity/activity/create',
    method: 'post',
    data
  })
}

/**
 * 获取活动详情(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function activityActivityGetDetail(data) {
  return request({
    type: 'biz',
    url: 'activity/activity/get/detail',
    method: 'post',
    data
  })
}

/**
 * 获取活动列表(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function activityActivityListAct(data) {
  return request({
    type: 'biz',
    url: 'activity/activity/list/act',
    method: 'post',
    data
  })
}

/**
 * 获取参与家长列表(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function activityActivityListRealParent(data) {
  return request({
    type: 'biz',
    url: 'activity/activity/list/real/parent',
    method: 'post',
    data
  })
}

/**
 * 获取报名家长列表(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function activityActivityListRegistParent(data) {
  return request({
    type: 'biz',
    url: 'activity/activity/list/regist/parent',
    method: 'post',
    data
  })
}

/**
 * 编辑活动(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function activityActivityUpdateAct(data) {
  return request({
    type: 'biz',
    url: 'activity/activity/update/act',
    method: 'post',
    data
  })
}

/**
 * 编辑活动报名时间(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function activityActivityUpdateActRegisttime(data) {
  return request({
    type: 'biz',
    url: 'activity/activity/update/act/registTime',
    method: 'post',
    data
  })
}

/**
 * 修改活动状态(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function activityActivityUpdateActStatus(data) {
  return request({
    type: 'biz',
    url: 'activity/activity/update/act/status',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Activity.js